<div
  class="shade"
  [ngStyle]="{ display: dialogDisplay, opacity: dialogOpacity }"
>
  <div class="tip" *ngIf="authInvalid">
    <p class="fontSize16 lineHeight21">
<!--      您的英跃账号已于-->
<!--      {{ timeOneMinuteAgo }} 在其他设备上登录。如您需要继续学习，请重新登录。-->
      您的登录状态已经失效，请重新登录。
    </p>
    <button *ngIf="!isTencent" (click)="goToLoginPage()" id="continueBtn" class="btnWord">确定</button>
  </div>
  <div class="tip" *ngIf="courseInvalid">
    <p class="fontSize16 lineHeight21">
      <!-- 当前课程已过期。我们将导航您至其他课程继续学习。 -->
      您的当前账号已过期，请重新登录。
    </p>
    <button *ngIf="!isTencent" (click)="goToLearnigMapOrCourseSelect()" id="continueBtn" class="btnWord">重新登录</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/user-available-asking/user-available-asking.component.html